<template>
  <vx-card v-if="editableOpeningHours" no-shadow>
    <popup-add-special-day v-on:onAdd="onDayAdd" ref="popupAddSpecialDay" />
    <h2 class="mb-6">Opening Hours</h2>

    <h5 class="mb-6">Special opening hours</h5>

    <!-- Special days start -->
    <div>
      <vs-button
        class="vs-con-loading__container mb-3"
        type="relief"
        vslor="primary"
        @click="$refs.popupAddSpecialDay.show()"
        >Add day</vs-button
      >
      

      <!-- table -->
      <div id="data-list-list-view" class="data-list-container">
        <!-- <h3>{{ activeVenue.name }}</h3> -->

        <vs-table
          ref="table"
          max-items="20"
          pagination
          :data="openingHours.specialOpeningHours"
        >
          <template slot="thead">
            <vs-th sort-key="">Day</vs-th>
            <vs-th sort-key="">Is open</vs-th>
            <vs-th sort-key="">Opens at</vs-th>
            <vs-th sort-key="">Closes at</vs-th>
            <vs-th sort-key="">Actions</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="idx" v-for="(tr, idx) in data">
                <vs-td>
                  <vs-chip>
                    <feather-icon
                      icon="ClockIcon"
                      svg-classes="h-3 w-3 mr-1"
                    /><span> {{ tr.day | date }}</span>
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip :color="tr.isOpen ? 'primary' : 'dark'">
                    {{ tr.isOpen | yesno }}</vs-chip
                  >
                </vs-td>

                <vs-td>
                  <p v-if="tr.isOpen" class="product-category">
                    {{ tr.open | timeFormat }}
                  </p>
                  <p v-else class="product-category">N/A</p>
                </vs-td>

                <vs-td>
                  <p v-if="tr.isOpen" class="product-category">
                    {{ tr.close | timeFormat }}
                  </p>
                  <p v-else class="product-category">N/A</p>
                </vs-td>

                <vs-td>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-4"
                    @click.stop="deleteDate(idx)"
                  />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>

    <small>Opening hours earlier than today are not shown here.</small>
    <!-- Special days end -->

    <vs-divider />
    <h5 class="mb-6">Regular opening hours</h5>

    <div class="vx-row mb-6">
      <venue-opening-hours-day
        day="Monday"
        :openingHours="editableOpeningHours.monday"
      />
      <venue-opening-hours-day
        day="Tuesday"
        :openingHours="editableOpeningHours.tuesday"
      />
      <venue-opening-hours-day
        day="Wednesday"
        :openingHours="editableOpeningHours.wednesday"
      />
      <venue-opening-hours-day
        day="Thursday"
        :openingHours="editableOpeningHours.thursday"
      />
      <venue-opening-hours-day
        day="Friday"
        :openingHours="editableOpeningHours.friday"
      />
      <venue-opening-hours-day
        day="Saturday"
        :openingHours="editableOpeningHours.saturday"
      />
      <venue-opening-hours-day
        day="Sunday"
        :openingHours="editableOpeningHours.sunday"
      />
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        v-if="hasPermissionForActiveVenue('vp.vp.venueinfo.edit')"
        @click="saveOpeningHours"
        id="save-button"
        class="ml-auto mt-2"
        >Save Opening Hours</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import VenueOpeningHoursDay from "./VenueOpeningHoursDay.vue";
import PopupAddSpecialDay from "./PopupAddSpecialDay.vue";
import moment from "moment"
export default {
  components: {
    VenueOpeningHoursDay,
    PopupAddSpecialDay,
  },
  data() {
    return {
      editableOpeningHours: null,
    };
  },
  computed: {
    ...mapGetters({
      openingHours: "venues/openingHours",
    }),
  },
  methods: {
    deleteDate(idx) {
      this.editableOpeningHours.specialOpeningHours.splice(idx, 1);
    },
    onDayAdd(day) {
      this.editableOpeningHours.specialOpeningHours.push(day);
    },
    async saveOpeningHours() {
      console.log("Posting ", this.editableOpeningHours);
      // parse every day price to int
      for (let day in this.editableOpeningHours) {
        this.editableOpeningHours[day].entrancePrice = parseInt(
          this.editableOpeningHours[day].entrancePrice
        );
        this.editableOpeningHours[day].wardrobePrice = parseInt(
          this.editableOpeningHours[day].wardrobePrice
        );
      }

      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45,
      });

      this.$store
        .dispatch("venues/updateOpeningHours", this.editableOpeningHours)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Opening hours saved",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save opening hours: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("venues/getOpeningHours");
    this.editableOpeningHours = this.openingHours;

    // filter special opening hours to only contain days on dates today or after today by comparing with moment.js
    this.editableOpeningHours.specialOpeningHours = this.editableOpeningHours.specialOpeningHours.filter(
      (day) => {
        return moment(day.day).isSameOrAfter(moment().subtract(1, 'day'));
      }
    )

    // Sort special opening hours by day
    this.editableOpeningHours.specialOpeningHours.sort((a, b) => {
      return moment(a.day).diff(moment(b.day));
    }).reverse();

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.day {
  font-weight: 500;
  width: 100px;
}

.opening-hours-row {
  display: flex;
  align-items: center;
  min-height: 40px;
}
</style>